// RUTA: src/components/ExpandingCard/ExpandingCard.tsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import * as S from "./ExpandingCard.styles";
import { CardInfo, SubItem } from "./cardData";
import { createGlobalStyle } from "styled-components";

// Props que recibirá nuestro componente
interface CardProps {
  cardInfo: CardInfo;
  isExpanded: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

// Variantes de animación para la cuadrícula
const subItemsGridVariants = {
  // Estado inicial: invisible
  initial: { opacity: 0 },
  // Estado animado: visible, y anima a sus hijos con un retraso
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05, // Retraso de 0.05s entre cada item
    },
  },
  // Estado al salir: invisible
  exit: { opacity: 0 },
};

// Variantes de animación para cada item individual
const subItemVariants = {
  initial: { opacity: 0, y: 20 }, // Empieza invisible y 20px más abajo
  animate: { opacity: 1, y: 0 }, // Termina visible y en su posición original
};

const ExpandingCard: React.FC<CardProps> = ({
  cardInfo,
  isExpanded,
  onMouseEnter,
  onMouseLeave,
}) => {
  const navigate = useNavigate();
  const hasSubItems = cardInfo.subItems && cardInfo.subItems.length > 0;

  const handleClick = () => {
    if (!hasSubItems && cardInfo.path) {
      navigate(cardInfo.path);
    }
  };

  const hoverProps = hasSubItems ? { onMouseEnter, onMouseLeave } : {};
  const IconStyle = createGlobalStyle`
  .card-icon-custom svg {
    fill: #EF872F !important;
  }
`;
  return (
    <S.CardWrapper
      layout
      onClick={handleClick}
      {...hoverProps}
      transition={{ layout: { duration: 0.4, type: "spring" } }}
      whileHover={{ scale: 1.03 }}
    >
       <IconStyle />
      <S.CardHeader layout>
        {/* ✅ Pasamos un className al componente del icono */}
        <div className="card-icon-custom">
          <cardInfo.icon width="60px" height="60px" />
        </div>
        <S.Title>{cardInfo.title}</S.Title>
      </S.CardHeader>


      <AnimatePresence>
        {isExpanded && hasSubItems && (
          <S.SubItemsGrid
            key="sub-items-grid"
            variants={subItemsGridVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {cardInfo.subItems?.map((item: SubItem) => (
              // Cada item se envuelve en un motion.div para aplicar la animación individual
              <motion.div key={item.name} variants={subItemVariants}>
                <S.SubItem to={item.path}>{item.name}</S.SubItem>
              </motion.div>
            ))}
          </S.SubItemsGrid>
        )}
      </AnimatePresence>
    </S.CardWrapper>
  );
};

export default ExpandingCard;
